// Bootstrap
(function() {
  'use strict';
  window.addEventListener('load', function() {
  	var forms = document.getElementsByClassName('needs-validation');
  	var validation = Array.prototype.filter.call(forms, function(form) {
  	  form.addEventListener('submit', function(event) {
  	  	if (form.checkValidity() === false) {
  	  	  event.preventDefault();
  	  	  event.stopPropagation();
  	  	}
  	  	form.classList.add('was-validated');
  	  }, false);
  	});
  }, false);
})();

$(function() {
  
  // Full Calendar
  if($('.calendar').length > 0) {
    $('.calendar').fullCalendar({
      themeSystem: 'bootstrap4',
      header: {
        left: 'prev,next',
        right: 'title'
      },
      weekNumbers: false,
      eventLimit: true,
      googleCalendarApiKey: 'AIzaSyA6xsxg1gwdh7fgGuPciEW2lWaac9NMXTM',
      events: {
        googleCalendarId: 'endemolshine.pointlessgame@gmail.com',
        className: 'gcal-event'
      }
    });
  }

  // Tooltip
  $('[data-toggle="tooltip"]').tooltip();

  // Datatable
  /*
  if($('#datatable').length > 0) {
    $('#datatable').DataTable({
      'order': [],
      'columnDefs': [{
        'targets': 'no-sort',
        'orderable': false,
      }]
    });
  }
  */

  // Lightbox
  $(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });

  // Ajax
  /*
  $(document ).ajaxStart(function() {
    $.blockUI({
      message: 'Please wait ...',
      css: { border: '1px solid #000000', backgroundColor: '#000000', color: '#ffffff', width: '150px', left: '45%', padding: '30px' }
    });
  });

  $(document).ajaxComplete(function() {
    $.unblockUI();
  });
  */
});